(() => {
  const normalize = value => value.trim().toLowerCase();
  const skipCollection = handle => ['all', 'all-products', 'all-products-1', 'frontpage', 'newest-products', 'best-selling-products'].includes(normalize(handle || ''));
  async function init(root) {
    if (root.dataset.filtersReady) return;
    root.dataset.filtersReady = 'true';
    const bar = root.querySelector('[data-gx-filters]');
    const grid = root.querySelector('[data-gx-collection-grid]');
    const gender = bar.querySelector('[data-gx-filter-gender]');
    const collection = bar.querySelector('[data-gx-filter-collection]');
    const color = bar.querySelector('[data-gx-filter-color]');
    const size = bar.querySelector('[data-gx-filter-size]');
    const clear = bar.querySelector('[data-gx-filter-clear]');
    const status = bar.querySelector('[data-gx-filter-status]');
    const pagination = root.querySelector('[data-gx-collection-pagination]');
    bar.hidden = false;
    try {
      // Read every collection page before enabling filters, never just the first 24 products.
      let next = root.querySelector('[data-gx-collection-next]')?.href;
      const firstPage = new URL(location.href);
      if (Number(firstPage.searchParams.get('page') || 1) > 1) { firstPage.searchParams.delete('page'); next = firstPage.href; }
      const seen = new Set();
      const cards = [...grid.querySelectorAll('[data-gx-filter-product]')];
      const ids = new Set(cards.map(card => card.dataset.productId));
      while (next) {
        if (seen.has(next)) break;
        seen.add(next);
        try {
          const response = await fetch(next, {credentials:'same-origin'});
          if (!response.ok) break;
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const collectionRoot = doc.querySelector('[data-gx-collection]');
          if (!collectionRoot) break;
          collectionRoot.querySelectorAll('[data-gx-filter-product]').forEach(card => {
            if (!ids.has(card.dataset.productId)) { ids.add(card.dataset.productId); cards.push(card); }
          });
          const link = collectionRoot.querySelector('[data-gx-collection-next]');
          next = link ? new URL(link.getAttribute('href'), response.url).href : null;
        } catch (pageError) {
          // A single page failing to load (flaky mobile network, etc.) shouldn't
          // break filtering for the products already gathered so far.
          break;
        }
      }
      const records = cards.map(card => {
        try {
          const data = JSON.parse(card.querySelector('[data-gx-filter-options]').textContent);
          const names = (data.options || []).map(normalize);
          const collections = (data.collections || [])
            .filter(item => item?.handle && !skipCollection(item.handle))
            .map(item => ({handle: normalize(item.handle), title: item.title || item.handle}));
          return {
            card,
            gender: normalize(data.gender || card.dataset.gxGender || 'unisex'),
            collections,
            variants: data.variants || [],
            colorIndex: names.findIndex(n => ['color','colour','لون','اللون'].includes(n)),
            sizeIndex: names.findIndex(n => ['size','المقاس','مقاس'].includes(n))
          };
        } catch (recordError) {
          return {card, gender: 'unisex', collections: [], variants: [], colorIndex: -1, sizeIndex: -1};
        }
      });
      function populate(select,indexKey) {
        const values = new Map();
        records.forEach(record => record.variants.forEach(variant => {
          const value = variant.options[record[indexKey]];
          if (value) values.set(normalize(value),value);
        }));
        const sizeOrder = ['xxs','xs','s','m','l','xl','xxl','2xl','xxxl','3xl','4xl','5xl'];
        [...values].sort((a,b) => {
          if (indexKey === 'sizeIndex' && sizeOrder.includes(a[0]) && sizeOrder.includes(b[0])) return sizeOrder.indexOf(a[0])-sizeOrder.indexOf(b[0]);
          return a[1].localeCompare(b[1],undefined,{numeric:true});
        }).forEach(([key,label]) => { const option = document.createElement('option'); option.value=key; option.textContent=label; select.append(option); });
        select.disabled = !values.size;
      }
      function populateGender(select) {
        const values = new Set(records.map(record => record.gender).filter(value => value === 'men' || value === 'women'));
        [['men', window.GX.s('filterMen', 'Men')],['women', window.GX.s('filterWomen', 'Women')]].forEach(([key,label]) => {
          if (!values.has(key)) return;
          const option = document.createElement('option');
          option.value = key;
          option.textContent = label;
          select.append(option);
        });
        select.disabled = !values.size;
      }
      function populateCollection(select) {
        const values = new Map();
        records.forEach(record => record.collections.forEach(item => {
          if (item.handle) values.set(item.handle, item.title);
        }));
        [...values].sort((a,b) => a[1].localeCompare(b[1], undefined, {sensitivity:'base'})).forEach(([key,label]) => {
          const option = document.createElement('option');
          option.value = key;
          option.textContent = label;
          select.append(option);
        });
        select.disabled = !values.size;
      }
      populateGender(gender);
      populateCollection(collection);
      populate(color,'colorIndex');
      populate(size,'sizeIndex');
      cards.forEach(card => grid.append(card));
      pagination.hidden = true;
      function apply(save = true) {
        let count = 0;
        records.forEach(record => {
          const genderMatch = !gender.value || record.gender === gender.value;
          const collectionMatch = !collection.value || record.collections.some(item => item.handle === collection.value);
          const matches = genderMatch && collectionMatch && record.variants.some(variant =>
            (!color.value || normalize(variant.options[record.colorIndex] || '') === color.value) &&
            (!size.value || normalize(variant.options[record.sizeIndex] || '') === size.value)
          );
          record.card.hidden = !matches;
          if (matches) count++;
        });
        status.textContent = window.GX.productCountLabel(count);
        root.querySelector('[data-gx-filter-empty]').hidden = count !== 0;
        clear.disabled = !gender.value && !collection.value && !color.value && !size.value;
        if (save) {
          const url = new URL(location.href);
          [['gx_gender',gender.value],['gx_collection',collection.value],['gx_color',color.value],['gx_size',size.value]].forEach(([key,value]) => value ? url.searchParams.set(key,value) : url.searchParams.delete(key));
          url.searchParams.delete('page');
          history.replaceState(null,'',url);
        }
      }
      const params = new URLSearchParams(location.search);
      const genderParam = params.get('gx_gender') || '';
      gender.value = (genderParam === 'men' || genderParam === 'women') ? genderParam : '';
      const collectionParam = normalize(params.get('gx_collection') || '');
      collection.value = [...collection.options].some(option => option.value === collectionParam) ? collectionParam : '';
      color.value = params.get('gx_color') || '';
      size.value = params.get('gx_size') || '';
      gender.addEventListener('change',() => apply());
      collection.addEventListener('change',() => apply());
      color.addEventListener('change',() => apply());
      size.addEventListener('change',() => apply());
      clear.addEventListener('click',() => { gender.value=''; collection.value=''; color.value=''; size.value=''; apply(); });
      apply(true);
    } catch (error) {
      status.textContent = window.GX.s('filtersFailed', 'Filters could not load. Refresh to try again.');
      // Original products and pagination remain usable if a request fails.
    }
  }
  const scan = scope => scope.querySelectorAll('[data-gx-collection]').forEach(init);
  document.addEventListener('DOMContentLoaded',() => scan(document));
  document.addEventListener('shopify:section:load',event => scan(event.target));
})();
